import React from "react";

// 🔷 Components Import
import Newhome from "./Newhome"; // Header + Banner

import Newhomefooter from "./Newhomefooter";
import ScreenReader from "./ScreenReader";

const Screenreaderpage = () => {
  return (
    <>
    <div className="home-page-new">
      {/* 🔷 HEADER + HERO */}
      <Newhome />

      {/* 🔷 Screen Reader */}
    
      <ScreenReader />
      <Newhomefooter />
      </div>
    </>
  );
};

export default Screenreaderpage;